import { render, staticRenderFns } from "./addPayroll.vue?vue&type=template&id=becc2a9a&scoped=true&"
import script from "./addPayroll.vue?vue&type=script&lang=js&"
export * from "./addPayroll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "becc2a9a",
  null
  
)

export default component.exports